import { EventEmitter } from '@angular/core';
import { Inject } from '@angular/core';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { Component, OnInit } from '@angular/core';
import { AzureTokenBlobPipe } from 'app/shared/pipes/azureBlobToken.pipe';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RGuestMessages } from 'app/model/shared/backend-api-response/rguest-messages';
import { Permissions } from 'app/model/shared/backend-api-response/permissions';
import { GoogleAnalyticsEventsService } from 'modules/shared/legacy-bookexpress/services/google-analytics-events.service';

declare const gtag: Function;

@Component({
  selector: 'app-offer-details',
  templateUrl: 'offerDetails.component.html',
  styleUrls: ['./offerDetails-style-handler.component.scss'],
})
export class offerDetailsComponent {
  public assetsURL: string;
  public rGuestBookPermissions: Permissions;
  public rGuestBookMessages: RGuestMessages;
  public offerConfigCloud: any = false;
  onAdd = new EventEmitter();
  constructor(
    public dialogRef: MatDialogRef<offerDetailsComponent>,
    public AppInitializer: LegacyBookInitService,
    public azureBlobToken: AzureTokenBlobPipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private googleAnalytics: GoogleAnalyticsEventsService
  ) {
    this.rGuestBookPermissions = this.AppInitializer.PropertyData.permissions;
    this.rGuestBookMessages = this.AppInitializer.PropertyData.rGuestMessages;
    this.offerConfigCloud = this.AppInitializer.offerConfigCloud;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
    setTimeout(() => {
      (<any>$('.carousel')).carousel();
    }, 300);

    this.assetsURL = this.AppInitializer.PropertyData.UrlMap.ImageUrl;
    if (this.data) {
      //  $('html').css('overflow', 'auto');
      $('body').css('overflow', 'initial');

      this.googleAnalytics.eventEmitter('view_details', 'offers', 'view_details_clicked', 'offers Details Viewed');
      console.log(this.data);
    }
  }
  checkAndBook(data) {
    this.onAdd.emit(data);
  }
  errorOfferImageHandler(event, imgIndex) {
    if (this.rGuestBookPermissions.functionalPermissions.blockDefaultImage) {
      this.data.offerImageList.splice(imgIndex, 1);
    } else {
      event.target.src = this.azureBlobToken.transform(this.AppInitializer.PropertyData.UrlMap.defaultOfferImageUrl);
    }
  }
}
